import { useLayoutEffect, useState } from "react"

const mediaQueryMap = {
  xs: "(max-width:639px)",
  sm: "(min-width: 640px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1280px)",
} as const
/**
 * 媒体查询钩子
 * @param query 媒体查询的值，有四个便捷值sm、md、lg、xl与tailwind的一致
 * @returns 是否匹配
 */
export function useMediaQuery<T extends string = keyof typeof mediaQueryMap>(
  query: T,
): boolean {
  const queryStr = (mediaQueryMap as any)[query] || query
  const [matches, setMatches] = useState(() => matchMedia(queryStr).matches)

  useLayoutEffect(() => {
    const mediaQuery = matchMedia(queryStr)

    function onMediaQueryChange(): void {
      setMatches(mediaQuery.matches)
    }

    mediaQuery.addEventListener("change", onMediaQueryChange)

    return (): void => {
      mediaQuery.removeEventListener("change", onMediaQueryChange)
    }
  }, [query, queryStr])

  return matches
}
